import { createStrictContext } from '@/shared/lib/createStrictContext';

interface RemoveWidgetContextType {
  openRemoveModal: (onOk: () => void) => void;
}

export const { useStrictContext: useRemoveWidgetContext, Provider: RemoveWidgetProvider } =
  createStrictContext<RemoveWidgetContextType>('RemoveWidget');
